import React, { Component } from 'react';

import CopyProvider from '../copy_provider';
import './error.css';

export default class Error extends Component {
  render() {
    return (
      <div className="error_body">
        <div className="error_body_content darken-overlay">
          <div className="error_body_content_header">
            <CopyProvider copyKey={ `error_title_${this.props.error}` } />
          </div>

          <div className="error_body_content_body">
            <CopyProvider copyKey={ `error_subtitle_${this.props.error}` } />
          </div>

          <div className="error_body_content_form">
            <CopyProvider copyKey={ `error_button_${this.props.error}` } />
          </div>

          <div className="error_body_content_footer">
            <CopyProvider copyKey={ `error_code_${this.props.error}` } error={ this.props.message } />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/content/error/error.js